import gallery from '../Images/gallerywhitelace.png'
import '../styles/Details.css'

function Details() {
  return (
    <img src={gallery} alt="About us" className='responsive-image'/>
  );
}

export default Details;
